import { render, staticRenderFns } from "./ScoreTable.vue?vue&type=template&id=f07e7056&scoped=true"
import script from "./ScoreTable.vue?vue&type=script&lang=js"
export * from "./ScoreTable.vue?vue&type=script&lang=js"
import style0 from "./ScoreTable.vue?vue&type=style&index=0&id=f07e7056&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f07e7056",
  null
  
)

export default component.exports